var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "waypoint",
          rawName: "v-waypoint",
          value: {
            active: true,
            callback: _vm.numbers,
            options: _vm.numbersIntersectionOptions
          },
          expression:
            "{ active: true, callback: numbers, options: numbersIntersectionOptions }"
        }
      ],
      staticClass: "item"
    },
    [
      _vm.figure
        ? _c(
            "span",
            { staticClass: "item__number" },
            [
              _c("animate-number", {
                ref: "myNum-" + _vm.loopindex,
                attrs: { to: _vm.figure, from: "0", mode: "manual" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.label
        ? _c("span", { staticClass: "item__text" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }